package com.eladfinish.bible.contest.screens.mikud.ui

import androidx.compose.animation.AnimatedContent
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.material3.Checkbox
import androidx.compose.material3.CheckboxDefaults
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.colorAccent
import com.eladfinish.bible.contest.perek_str
import com.eladfinish.bible.contest.pirkei
import com.eladfinish.bible.contest.screens.mikud.model.BookState
import com.eladfinish.bible.contest.screens.mikud.model.ChapterClickData
import com.eladfinish.bible.contest.screens.mikud.model.ChapterUi
import com.eladfinish.bible.contest.ui.components.mouseVerticalScrollbar
import com.eladfinish.bible.contest.ui.extensions.navigationBarContentPadding
import com.eladfinish.bible.contest.utils.addGershaim
import com.eladfinish.bible.contest.utils.toOtiot
import dev.icerock.moko.resources.compose.colorResource
import dev.icerock.moko.resources.compose.stringResource
import kotlinx.collections.immutable.ImmutableList
import kotlinx.collections.immutable.toImmutableList

@Composable
internal fun ChapterList(
    mikudState: ImmutableList<BookState>,
    bookIndex: Int,
    onClick: (ChapterClickData) -> Unit = {},
) {
    Column {
        Text(
            text = stringResource(resource = SharedRes.strings.pirkei).plus(" ")
                .plus(mikudState[bookIndex].name).plus(":"),
            modifier = Modifier,
            color = Color.Black,
            fontWeight = FontWeight.Bold,
            textAlign = TextAlign.Right,
            style = MaterialTheme.typography.bodySmall.copy(fontSize = 22.sp),
        )

        AnimatedContent(
            targetState = bookIndex,
            content = {
                ChapterCheckboxList(
                    chapters = buildListOfChapters(bookState = mikudState[bookIndex]),
                    bookIndex = bookIndex,
                    onClick = onClick,
                )
            },
        )
    }
}

@Composable
private fun buildListOfChapters(
    bookState: BookState,
): ImmutableList<ChapterUi> {
    return bookState.chapters.mapIndexed { index, checked ->
        ChapterUi(
            index = index,
            name = stringResource(resource = SharedRes.strings.perek_str)
                .plus(" ")
                .plus(
                    index.plus(1)
                        .toOtiot()
                        .addGershaim()
                ),
            checked = checked,
        )
    }.toImmutableList()
}

@Composable
private fun ChapterCheckboxList(
    chapters: ImmutableList<ChapterUi>,
    bookIndex: Int,
    onClick: (ChapterClickData) -> Unit = {},
) {
    val listState = rememberLazyListState()

    LazyColumn(
        state = listState,
        modifier = Modifier.mouseVerticalScrollbar(listState),
        contentPadding = navigationBarContentPadding(),
    ) {
        items(
            items = chapters,
            key = { it.name }
        ) { chapterData ->
            Row(
                modifier = Modifier
                    .padding(1.dp),
                verticalAlignment = Alignment.CenterVertically,
            ) {
                val index = chapterData.index
                val text = chapterData.name
                Checkbox(
                    colors = CheckboxDefaults.colors(
                        checkedColor = colorResource(resource = SharedRes.colors.colorAccent),
                        uncheckedColor = Color.DarkGray,
                        checkmarkColor = Color.Black,
                    ),
                    checked = chapterData.checked,
                    modifier = Modifier
                        .padding(horizontal = 2.dp)
                        .align(alignment = Alignment.CenterVertically),
                    onCheckedChange = {
                        onClick.invoke(
                            ChapterClickData(
                                bookIndex = bookIndex,
                                chapterIndex = index,
                                selected = it,
                            )
                        )
                    },
                )
                Text(
                    text = text,
                    modifier = Modifier
                        .align(alignment = Alignment.CenterVertically)
                        .clickable(
                            onClick = {
                                onClick.invoke(
                                    ChapterClickData(
                                        bookIndex = bookIndex,
                                        chapterIndex = index,
                                        selected = chapterData.checked.not(),
                                    )
                                )
                            },
                        ),
                    color = Color.Black,
                    fontSize = 17.sp,
                    textAlign = TextAlign.Right,
                )
            }
        }
    }
}
